(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('PropertiesCtrl', ['$scope', '$rootScope', '$stateParams', 'profilesService', 'growlService', '$timeout', '$state', 'profileHelper',
            function ($scope, $rootScope, $stateParams, profilesService, growlService, $timeout, $state, profileHelper) {
                $scope.edit = false;
                $scope.configuredProfiles = profileHelper.getProfile();
                $scope.configuredProfilesCopy = angular.copy($scope.configuredProfiles);

                $scope.generalPropertiesList = Object.keys($scope.configuredProfiles.generalProperties.properties);
                $scope.duplicates = {};

                $scope.customCheck = function (value) {
                    if (value) {
                        return (!/^[a-zA-Z0-9-_]*$/.test(value) || value.startsWith("_"));
                    }
                    return false;
                };
                $scope.customChecks = function () {
                    for (var i in $scope.newProperties) {
                        if ($scope.customCheck($scope.newProperties[i].key)) return true;
                    }
                    return false;
                };

                $scope.addVariable = function () {
                    $scope.newProperties.push({});
                };
                $scope.deleteVariable = function (index) {
                    $scope.newProperties.splice(index, 1);
                };

                $scope.$on('profile:edit', function(){
                    $scope.edit = true;
                    $scope.newProperties = [];
                });

                $scope.$on('profile:save', function(){
                    $scope.save();
                    $scope.edit = false;
                });

                $scope.$on('profile:cancel', function(){
                    $scope.edit = false;
                });

                $scope.save = function () {
                    if ($scope.newProperties.length > 0) {
                        for (var i in $scope.newProperties) {
                            if ($scope.newProperties[i].key) {
                                $scope.configuredProfiles.customProperties.properties[$scope.newProperties[i].key] = {
                                    label: $scope.newProperties[i].key,
                                    value: $scope.newProperties[i].value,
                                    type: 'string'
                                };
                                $scope.configuredProfiles.customProperties.subProperties = true;
                            }
                        }
                    }

                    var profile = profileHelper.getProfileData($scope.configuredProfiles, $scope.configuredProfilesCopy);
                    var profileToPatch = profile.dataToPatch;
                    var propertiesToDelete = profile.emptyProperties;

                    var id = $scope.configuredProfiles.generalProperties.properties.id.value;
                    profilesService.patchProfile($stateParams.pickedApiSpaceId, id, profileToPatch, propertiesToDelete).then(function (result) {
                        $scope.edit = false;
                        $scope.configuredProfilesCopy = angular.copy($scope.configuredProfiles);
                        growlService.success("Profile successfully updated");
                        $rootScope.$broadcast("profile:patched", result);
                    }).catch(function (error) {
                        growlService.danger("Profile wasn't updated due to: " + error.statusText);
                    });
                };
                $scope.getPropertyByName = function (propertyName) {
                    var property = $scope.configuredProfiles;
                    var splitName = propertyName.split('.');
                    for (var i = 0; i < splitName.length - 1; i++) {
                        property = property[splitName[i]].properties;
                    }
                    return property[splitName[splitName.length - 1]];
                };
            }]);

})(window.angular);
